module.exports = __webpack_public_path__ + "img/shcs_cbhs.prt.0ac63203.jpg";